module.exports = __webpack_public_path__ + "static/media/noti5.7ecc7730.png";